.container {
  width: 100%;
  height: 100%;
  display: grid;
  gap: 0.5rem;
}

.logo-title {
  width: 100%;
  display: flex;
  gap: 3rem;
}

.logo-title hgroup > * {
  margin: 0;
  padding: 0 0 0.2rem 0;
}

.logo-title h1 {
  font-size: 1.5rem;
}

.toolbar {
  margin-top: 0.5rem;
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: end;
  gap: 1rem;
}
